<template>
  <div></div>
</template>

<script>
export default {
  name: "RedirectWithPermission",
  components: {},
  data: () => ({}),
  computed: {},
  mounted() {
    this.redirectByPermission();
  },
  beforeDestroy() {},
  methods: {
    redirectByPermission() {
      if (this.checkPermission(["super_admin"])) {
        this.$router.push({ name: "Dashboard" });
      } else if (this.checkPermission(["e_rent_branch"])) {
        this.$router.push({ name: "RentBranch" });
      } else if (this.checkPermission(["rent_collaborator"])) {
        this.$router.push({ name: "RentCollaborator" });
      } else if (this.checkPermission(["rent_collaborator_offline"])) {
        this.$router.push({ name: "RentCollaboratorOffline" });
      } else if (this.checkPermission(["rent_agency"])) {
        this.$router.push({ name: "RentAgency" });
      } else if (this.checkPermission(["rent_contract"])) {
        this.$router.push({ name: "RentContract" });
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    },
  },
};
</script>
